module.exports = __webpack_public_path__ + "static/img/201-3.45fe9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/201-3.jpg
// module id = mE56
// module chunks = 1